const homepageScrollYSessionStorageKey = "homepageScrollY";

export const saveHomepageScrollY = () => {
  try {
    if (typeof window === "undefined") {
      return;
    }
    window.sessionStorage.setItem(homepageScrollYSessionStorageKey, String(window.scrollY));
  } catch (error) {
    console.error(error);
  }
};

export const getHomepageScrollY = () => {
  try {
    if (typeof window === "undefined") {
      return null;
    }
    const homepageScrollY = window.sessionStorage.getItem(homepageScrollYSessionStorageKey);
    return homepageScrollY === null ? null : Number(homepageScrollY);
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const deleteHomepageScrollY = () => {
  try {
    if (typeof window === "undefined") {
      return;
    }
    window.sessionStorage.removeItem(homepageScrollYSessionStorageKey);
  } catch (error) {
    console.error(error);
  }
};

const homepageMultimediaScrollYSessionStorageKey = "homepageMultimediaScrollY";

export const saveHomepageMultimediaScrollY = (scrollY: number) => {
  try {
    if (typeof window === "undefined") {
      return;
    }
    window.sessionStorage.setItem(homepageMultimediaScrollYSessionStorageKey, String(scrollY));
  } catch (error) {
    console.error(error);
  }
};

export const getHomepageMultimediaScrollY = () => {
  try {
    if (typeof window === "undefined") {
      return null;
    }
    const multimediaScrollY = window.sessionStorage.getItem(
      homepageMultimediaScrollYSessionStorageKey,
    );
    return multimediaScrollY === null ? null : Number(multimediaScrollY);
  } catch (error) {
    console.error(error);
    return null;
  }
};
